import VSelect from 'vuetify/lib/components/VSelect/VSelect';

export default {
	name: 'VSelectFixed',
	extends: VSelect,
	data: () => ({
		blurHandled: false
	}),
	methods: {
		blur() {
			if (!this.blurHandled) {
				setTimeout(this.handleBlur, 0);
			}
		},
		onTabDown(e) {
			this.blurHandled = true;
			setTimeout(() => this.handleTabDown(e), 0);
		},
		handleBlur() {
			this.isMenuActive = false;
			this.isFocused = false;
			this.selectedIndex = -1;
			this.$nextTick(() => (this.blurHandled = false));
		},
		handleTabDown(e) {
			if (this.isMenuActive) {
				VSelect.options.methods.onTabDown.call(this, e);
			} else {
				this.handleBlur();
			}
		}
	}
};